<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { loginLog } from "@/util/api.js";

export default {
  data() {
    return {
      a: false,
    };
  },
  methods: {
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
  },
  mounted() {
    console.log(this.$store.state.onceRequest);
    if (!this.$store.state.onceRequest) {
      let _this=this
      setTimeout(() => {
        loginLog(
          {
            logType: 1,
            operateUser: $cookies.get("username"),
            modular: "登录系统",
            operateDesc: "登入系统",
            operateTime: _this.getNowFormatDate(),
          },
          $cookies.get("SSOID")
        ).then((res) => {
          console.log(res);
          _this.$store.commit("loginOnce", true);
        });
      }, 1000);
    }
  },
};
</script>
<style lang="scss">
</style>
